<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">

      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <img src="https://cdn.insightltd.cn/website/logo_black.png">
        </div>
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex ?'active':''"
          @click="navClick(index,item.name)"
        >
<!--          :to="{ path: item.path== '/software' ? '' : item.path  }"-->
          <router-link :to="{ path: item.path }">
            {{item.name}}
<!--            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>-->
            <i class="underline"></i>
          </router-link>
<!--          <dl v-if="item.children.length>0">-->
<!--            <dt :class="activeSel == i.active ? 'backT' : ''" v-for="(i,n) in item.children" :key="n" @click="secondClick(i.active)">-->
<!--              <div class="secondTitle" >{{i.name}}</div>-->
<!--            </dt>-->
<!--          </dl>-->
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
<!--      <div class="header-nav-m-logo">-->
<!--        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">-->
<!--      </div>-->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <div   data-toggle="collapse" data-target="#menu" @click="menuClick">
          {{menuName}}
          <div
            class="header-nav-m-menu-wrapper"



          >
            <span :class="menuClass"></span>
          </div>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex ?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <div @click="phoneClick(item.path)">
              {{item.name}}
            </div>
<!--            <router-link :to="item.path">-->
<!--              {{item.name}}-->
<!--              <i class="underline"></i>-->
<!--            </router-link>-->

          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import { state } from 'vuex';
  const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();
  export default {
    name: "Header",
    data() {
      return {
        activeSel:0,
        // navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
        // navIndex:0,

        // menuName: "首页",
        menuClass: "glyphicon glyphicon-menu-down",
        navList: [
          {
            name: "首页",
            path: "/",
            children: []
          },
          {
            name: "业务解决方案",
            path: "/software",
            children: [
              {
                name: "For医生",
                path: "/software",
                active:1,
              },
              {
                name: "For医疗机构",
                path: "/software",
                active:2,
              },
              {
                name: "For患者",
                path: "/software",
                active:3,
              },
              {
                name: "For医疗企业",
                path: "/software",
                active:4,
              },
            ]
          },
          {
            name: "技术解决方案",
            path: "/service",
            children: []
          },

          {
            name: "员工成长计划",
            path: "/companyintroduction",
            children: []
          },
          {
            name: "企业社会责任",
            path: "/newsinformation",
            children: []
          },
        ]
      };
    },
    computed:{
      // 通过VUEX获取高亮按钮状态(计算属性唯一性）
      navIndex(){
        return   this.$store.state.navIndex;
      },
      menuName(){
        return   this.$store.state.menuName;
      },
    },
    // 通过监听判断该计算属性是否变化过
    watch: {
    },
    created() {
    },
    methods: {
      navClick(index, name) {
        // this.navIndex = index;
        // sessionStorage.setItem('navIndex', index)
        this.$store.commit('saveNavIndex',index)
        this.$store.commit('saveMenuName',name)
        this.$store.commit('swiperFaleTap',0)
        console.log(index);
        // this.menuName = name;
      },
      menuClick() {
        if (this.menuClass == "glyphicon glyphicon-menu-down") {
          this.menuClass = "glyphicon glyphicon-menu-up";
        } else {
          this.menuClass = "glyphicon glyphicon-menu-down";
        }
      },
      // 点击跳转
      secondClick(active) {
        // 确保唯一性
        let activeT = active.toString() + Date.now()
        this.$store.commit('saveActive',activeT)

        if(this.$route.path != '/software'){
          this.$router.push({
            path: '/software',
          });
        }else {

        }


      },
      // 点击跳转
      phoneClick(path) {
        console.log(path);
        if(this.$route.path != path){
          this.$router.push({
            path: path,
          });
        }


      },
    }
  };
</script>
<style scoped>
  /* 顶部 */
  #header {
    background: #fff;
    transition: all ease 0.6s;
  }

  #header .header-top {
    height: 50px;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    background: #999;
  }

  /* 顶部的图标 */
  #header .header-top span {
    margin: 0 8px;
  }

  /* 导航栏 */
  #header .header-nav {
    width: 84%;
    height: 60px;
    margin: 0 auto;
  }

  /* 导航栏logo */
  .header-nav-logo {
    width: 14.5%;
  }

  /* 导航栏logo图片 */
  .header-nav-logo img {
    width: 103px;
    height: 31px;

  }

  /* 导航栏 导航容器 */
  #header .header-nav-fixed .header-nav-wrapper {
    line-height: 50px;
  }

  #header .header-nav .header-nav-wrapper {
    line-height: 60px;
    align-items: center;
    display: flex;
    margin: 0;
    max-width: 84%;
  }
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper > li {
    width: 190px;
    text-align: center;
    /*float: left;*/
    /*margin: 0 15px;*/
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper > li > a {
    color: #333;
    font-size: 18px;
    /*font-weight: bold;*/
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的下划线 */
  #header .header-nav .header-nav-wrapper > li > a > i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    background-color: #D83D22;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 12px;
    transition: transform ease 0.5s;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover {
    color: #D83D22;
    text-decoration: none;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;

  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover span {
    transform: rotate(180deg);
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
  #header .header-nav .header-nav-wrapper > li.active > a {
    color: #D83D22;
    text-decoration: none;
    border-bottom: 2px solid #D83D22;
  }

  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav .header-nav-wrapper > li > dl {
    display: none;
    position: absolute;
    width: 120px;
    top: 92%;
    left: 16%;
    z-index: 999999;
    box-shadow: 0 0 3px 1px #ccc;
    font-size: 14px;
    background: #fff;
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav .header-nav-wrapper > li > dl > dt {
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid #ccc;

  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
  #header .header-nav .header-nav-wrapper > li > dl > dt > a {
    color: #666 !important;

  }

  #header .header-nav .header-nav-wrapper > li > dl :hover div {
    text-decoration: none;
    color: #fff !important;

  }

  #header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
    text-decoration: none;
    color: #fff !important;

  }

  /* 导航栏 滑上一级导航显示二级导航 */
  #header .header-nav .header-nav-wrapper > li:hover dl {
    display: block;
  }

  #header .header-nav .header-nav-wrapper > li > dl > dt:hover {
    cursor: pointer;
    background: #D83D22;
  }
  .backT{
    background: #D83D22;
    color: #fff;
  }
  @media screen and (max-width: 997px) {
    #header .header-nav-m {
      position: relative;
    }

    /* 导航栏logo容器 */
    #header .header-nav-m .header-nav-m-logo {
      height: 80px;
      position: relative;
    }

    /* 导航栏logo图片 */
    #header .header-nav-m .header-nav-m-logo img {
      width: 103px;
      height: 31px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }

    /* 导航栏  菜单容器 */
    #header .header-nav-m .header-nav-m-menu {
      color: #fff;
      height: 50px;
      font-size: 14px;
      line-height: 50px;
      background: #D83D22;
      position: relative;
    }

    /* 导航栏 菜单图标 */
    #header .header-nav-m .header-nav-m-menu-wrapper {
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -20px;
      width: 50px;
      height: 40px;
      color: #fff;
      z-index: 999999;
      font-size: 12px;
    }

    /* 导航栏 */
    #header .header-nav-m .header-nav-m-wrapper {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      background: #D83D22;
      z-index: 9999999;
    }

    /* 导航栏 每个导航 */
    #header .header-nav-m .header-nav-m-wrapper > li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #ccc;
    }

    /* 导航栏 每个导航下面的 a 链接 */
    #header .header-nav-m .header-nav-m-wrapper > li > a {
      color: #fff;
      font-size: 12px;
      font-weight: bold;
      padding: 15px 0;
      position: relative;
    }

    /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
    #header .header-nav .header-nav-wrapper > li > a > span {
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue